export default __webpack_public_path__ + "static/media/gournay19.a4cf4a57.jpg";